"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.MemoSelect = void 0;
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var _CatchFromControl = require("../../CatchFromControl");
var _InputActions = _interopRequireDefault(require("../../InputActions/InputActions"));
var _SelectDropdown = _interopRequireDefault(require("../../SelectDropdown"));
var _Tooltip = _interopRequireDefault(require("../../Tooltip"));
var _styles = require("../../styles");
var _useSelectState2 = require("../hooks/useSelectState");
var _base = require("@mui/base");
var _CircularProgress = _interopRequireDefault(require("@mui/material/CircularProgress"));
var _InputAdornment = _interopRequireDefault(require("@mui/material/InputAdornment"));
var _NativeSelectInput = require("@mui/material/NativeSelect/NativeSelectInput");
var _selectClasses2 = _interopRequireWildcard(require("@mui/material/Select/selectClasses"));
var _useForkRef = _interopRequireDefault(require("@mui/material/utils/useForkRef"));
var _clsx2 = _interopRequireDefault(require("clsx"));
var _capitalize = _interopRequireDefault(require("lodash/capitalize"));
var _isNumber = _interopRequireDefault(require("lodash/isNumber"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["children", "onAnimationStart", "onChange", "onFocus", "onBlur"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var SelectSelect = (0, _styles.styled)('div', {
  name: 'Select',
  slot: 'Select',
  overridesResolver: function overridesResolver(props, styles) {
    var ownerState = props.ownerState;
    return [// Win specificity over the input base
    _defineProperty({}, "&.".concat(_selectClasses2["default"].select), styles.select), _defineProperty({}, "&.".concat(_selectClasses2["default"].select), styles[ownerState.variant]), _defineProperty({}, "&.".concat(_selectClasses2["default"].error), styles.error), _defineProperty({}, "&.".concat(_selectClasses2["default"].multiple), styles.multiple)];
  }
})(_NativeSelectInput.nativeSelectSelectStyles, _defineProperty({}, "&.".concat(_selectClasses2["default"].select), {
  height: 'auto',
  // Resets for multiple select with chips
  minHeight: '1.554em',
  // Required for select\text-field height consistency
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  background: 'transparent'
}));
var SelectNativeInput = (0, _styles.styled)('input', {
  name: 'MuiSelect',
  slot: 'NativeInput',
  overridesResolver: function overridesResolver(_props, styles) {
    return styles.nativeInput;
  }
})({
  bottom: 0,
  left: 0,
  position: 'absolute',
  opacity: 0,
  pointerEvents: 'none',
  width: '100%',
  boxSizing: 'border-box'
});
var useUtilityClasses = function useUtilityClasses(ownerState) {
  var classes = ownerState.classes,
    variant = ownerState.variant,
    disabled = ownerState.disabled,
    multiple = ownerState.multiple,
    open = ownerState.open,
    error = ownerState.error;
  var slots = {
    select: ['select', variant, disabled && 'disabled', multiple && 'multiple', error && 'error'],
    icon: ['icon', "icon".concat((0, _capitalize["default"])(variant)), open && 'iconOpen', disabled && 'disabled'],
    nativeInput: ['nativeInput']
  };
  return (0, _base.unstable_composeClasses)(slots, _selectClasses2.getSelectUtilityClasses, classes);
};
var SelectIcon = (0, _styles.styled)('svg', {
  name: 'MuiSelect',
  slot: 'Icon',
  overridesResolver: function overridesResolver(props, styles) {
    var ownerState = props.ownerState;
    return [styles.icon, ownerState.variant && styles["icon".concat((0, _capitalize["default"])(ownerState.variant))], ownerState.open && styles.iconOpen];
  }
})(_NativeSelectInput.nativeSelectIconStyles, {
  top: 'auto'
});
var useSelectStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    placeholder: {
      color: theme.palette.text.disabled
    },
    container: {
      paddingRight: function paddingRight(_ref5) {
        var actionsCount = _ref5.actionsCount;
        return actionsCount ? "".concat(actionsCount * 22 + 8, "px !important") : null;
      }
    },
    suffix: {
      position: 'relative',
      right: function right(_ref6) {
        var actionsCount = _ref6.actionsCount;
        return 22 * (actionsCount || 1) + 12;
      },
      color: 'inherit'
    }
  };
});
var MIN_WIDTH = 200;
var SelectInput = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _display;
  var displayTooltip = props.displayTooltip,
    autoFocus = props.autoFocus,
    autoWidth = props.autoWidth,
    className = props.className,
    value = props.value,
    label = props.label,
    dataCyLabel = props.dataCyLabel,
    options = props.options,
    searchOptions = props.searchOptions,
    multiple = props.multiple,
    disabled = props.disabled,
    hideSelectedOption = props.hideSelectedOption,
    firstSelected = props.firstSelected,
    IconComponent = props.IconComponent,
    inputRefProp = props.inputRef,
    labelId = props.labelId,
    name = props.name,
    onBlur = props.onBlur,
    onChangeProp = props.onChange,
    onFocus = props.onFocus,
    onCloseProp = props.onClose,
    onOpenProp = props.onOpen,
    readOnly = props.readOnly,
    renderValue = props.renderValue,
    renderTooltip = props.renderTooltip,
    required = props.required,
    SelectDisplayProps = props.SelectDisplayProps,
    PopoverProps = props.PopoverProps,
    MenuProps = props.MenuProps,
    tabIndexProp = props.tabIndex,
    dropdownWidth = props.dropdownWidth,
    dropdownAlign = props.dropdownAlign,
    withFilter = props.withFilter,
    markSelectedOption = props.markSelectedOption,
    type = props.type,
    variant = props.variant,
    progressColor = props.progressColor,
    filter = props.filter,
    placeholder = props.placeholder,
    displayPlaceholder = props.displayPlaceholder,
    loading = props.loading,
    fetching = props.fetching,
    dataCy = props.dataCy,
    renderOption = props.renderOption,
    renderGroup = props.renderGroup,
    displayEmpty = props.displayEmpty,
    emptyValue = props.emptyValue,
    chaneStrategy = props.chaneStrategy,
    MenuComponent = props.MenuComponent,
    MenuListComponent = props.MenuListComponent,
    withLabel = props.withLabel,
    canDeselect = props.canDeselect,
    withSelectAll = props.withSelectAll,
    withDeselectButton = props.withDeselectButton,
    searchExp = props.searchExp,
    isOptionDisabled = props.isOptionDisabled,
    onAdd = props.onAdd,
    addOptionLabel = props.addOptionLabel,
    groupBy = props.groupBy,
    favorits = props.favorits,
    favoritsLabel = props.favoritsLabel,
    actions = props.actions,
    onSearch = props.onSearch,
    minOptionCountForSearch = props.minOptionCountForSearch,
    isServerSideMode = props.isServerSideMode,
    isServerSideSearchScreen = props.isServerSideSearchScreen,
    isServerSideInitScreen = props.isServerSideInitScreen,
    dropdownInputPlaceholder = props.dropdownInputPlaceholder,
    getOptionValue = props.getOptionValue,
    suffix = props.suffix;
  var _selectClasses = useSelectStyles({
    actionsCount: actions === null || actions === void 0 ? void 0 : actions.length
  });
  var inputRef = React.useRef(null);
  var handleRef = (0, _useForkRef["default"])(ref, inputRefProp);
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    displayNode = _React$useState2[0],
    setDisplayNode = _React$useState2[1];
  var formControl = (0, _CatchFromControl.useFormControl)();
  var _useSelectState = (0, _useSelectState2.useSelectState)({
      onChange: onChangeProp,
      value: value,
      onOpen: onOpenProp,
      onClose: onCloseProp,
      chaneStrategy: chaneStrategy
    }),
    open = _useSelectState.open,
    selectedOptions = _useSelectState.selectedOptions,
    onChange = _useSelectState.onChange,
    onClose = _useSelectState.onClose,
    onOpen = _useSelectState.onOpen;
  var menuMinWidthState = React.useMemo(function () {
    if (autoWidth || !displayNode) {
      return undefined;
    }
    return displayNode.clientWidth < MIN_WIDTH ? MIN_WIDTH : displayNode.clientWidth;
  }, [open, autoWidth, displayNode]);
  var display = emptyValue ? emptyValue : '';
  // No need to display any value if the field is empty.
  var tooltip = '';
  if (selectedOptions.length || displayEmpty) {
    display = renderValue(selectedOptions);
    if (displayTooltip) {
      tooltip = renderTooltip(selectedOptions);
    }
  }
  var menuMinWidth = menuMinWidthState;
  var tabIndex;
  if (typeof tabIndexProp !== 'undefined') {
    tabIndex = tabIndexProp;
  } else {
    tabIndex = disabled ? null : 0;
  }
  var buttonId = SelectDisplayProps.id || (name ? "mui-component-select-".concat(name) : undefined);
  React.useImperativeHandle(handleRef, function () {
    return {
      focus: function focus() {
        displayNode.focus();
      },
      node: inputRef.current,
      value: display
    };
  }, [displayNode, display]);
  React.useEffect(function () {
    if (autoFocus && displayNode) {
      displayNode.focus();
    }
  }, [autoFocus, displayNode]);
  var handleMouseDown = function handleMouseDown(event) {
    // Ignore everything but left-click
    if (event.button !== 0) {
      return;
    }
    // Hijack the default focus behavior.
    event.preventDefault();
    displayNode.focus();
    onOpen(event);
  };
  var handleKeyDown = function handleKeyDown(event) {
    if (!readOnly && !disabled) {
      var validKeys = [' ', 'ArrowUp', 'ArrowDown',
      // The native select doesn't respond to enter on MacOS, but it's recommended by
      // https://www.w3.org/TR/wai-data-cy-practices/examples/listbox/listbox-collapsible.html
      'Enter'];
      if (validKeys.indexOf(event.key) !== -1) {
        event.preventDefault();
        onOpen(event);
      }
    }
  };
  var handleBlur = React.useCallback(function (event) {
    if (!open && onBlur) {
      onBlur(event);
    }
  }, [onBlur, open]);
  var placeholderVisible = !display && (!withLabel || formControl.focused || displayPlaceholder);
  var displayOrPlaceholder = placeholderVisible ? placeholder : display;
  var handleInputChange = function handleInputChange() {}; // noop function to prevent React Warning
  var ownerState = _objectSpread(_objectSpread({}, props), {}, {
    variant: variant,
    value: value,
    open: open,
    disabled: disabled,
    actionsCount: actions === null || actions === void 0 ? void 0 : actions.length
  });
  var classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(React.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip["default"], {
      title: tooltip || /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {}) // empty tooltip reload display node ref
      ,
      disableHoverListener: !tooltip,
      disableFocusListener: !tooltip,
      children: /*#__PURE__*/(0, _react.createElement)(SelectSelect, _objectSpread(_objectSpread({
        ref: setDisplayNode,
        tabIndex: tabIndex,
        role: 'button',
        "data-cy-disabled": disabled ? true : false,
        "data-cy-expanded": open ? true : undefined,
        "data-cy-haspopup": 'listbox',
        "data-cy-labelledby": [labelId, buttonId].filter(Boolean).join(' ') || undefined,
        "data-cy-label": dataCyLabel,
        "data-cy": dataCy,
        "data-cy-value": (_display = display) === null || _display === void 0 || (_display = _display.props) === null || _display === void 0 ? void 0 : _display['data-cy-value'],
        "data-testid": dataCy,
        onKeyDown: handleKeyDown,
        onMouseDown: disabled || readOnly ? null : handleMouseDown,
        onBlur: handleBlur,
        onFocus: onFocus
      }, SelectDisplayProps), {}, {
        ownerState: ownerState,
        className: (0, _clsx2["default"])(_selectClasses.container, SelectDisplayProps.className, classes.select, _defineProperty({}, _selectClasses.placeholder, placeholderVisible), className)
        // The id is required for proper a11y
        ,
        id: buttonId,
        key: buttonId
      }), displayOrPlaceholder)
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(SelectNativeInput, {
      value: displayOrPlaceholder,
      name: name,
      ref: inputRef,
      "data-cy-hidden": true,
      tabIndex: -1,
      className: classes.nativeInput,
      autoFocus: autoFocus,
      onChange: handleInputChange,
      ownerState: ownerState
    }), suffix ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_InputAdornment["default"], {
      className: _selectClasses.suffix,
      position: 'end',
      children: suffix
    }) : null, actions !== null && actions !== void 0 && actions.length && !(loading || !open && fetching) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_InputActions["default"], {
      children: actions.map(function (action, index) {
        return /*#__PURE__*/React.cloneElement(action, {
          key: index
        });
      })
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(SelectIcon, _objectSpread({
      as: IconComponent,
      className: classes.icon,
      ownerState: _objectSpread(_objectSpread({}, ownerState), (loading || !open && fetching) && {
        color: progressColor
      })
    }, loading || !open && fetching ? {
      as: _CircularProgress["default"],
      color: progressColor,
      size: 24
    } : null)), loading ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_SelectDropdown["default"], {
      canDeselect: canDeselect,
      open: open,
      options: isServerSideSearchScreen ? searchOptions : options,
      isServerSideMode: isServerSideMode,
      isServerSideInitScreen: isServerSideInitScreen,
      displayNode: displayNode,
      value: value,
      selectedOptions: selectedOptions,
      renderOption: renderOption,
      renderGroup: renderGroup,
      filterOption: filter,
      onClose: onClose,
      onChange: onChange,
      width: (0, _isNumber["default"])(dropdownWidth) ? dropdownWidth : menuMinWidth,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: dropdownAlign
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: dropdownAlign
      },
      withFilter: withFilter,
      withSelectAll: withSelectAll,
      searchExp: searchExp,
      MenuProps: MenuProps,
      PopoverProps: PopoverProps,
      markSelectedOption: markSelectedOption,
      MenuComponent: MenuComponent,
      MenuListComponent: MenuListComponent,
      withDeselectButton: withDeselectButton,
      isOptionDisabled: isOptionDisabled,
      onAdd: onAdd,
      addOptionLabel: addOptionLabel,
      favoritsLabel: favoritsLabel,
      groupBy: groupBy,
      favorits: favorits,
      multiple: multiple,
      hideSelectedOption: hideSelectedOption,
      firstSelected: firstSelected,
      loading: loading,
      fetching: fetching,
      onSearch: onSearch,
      minOptionCountForSearch: minOptionCountForSearch,
      inputPlaceholder: dropdownInputPlaceholder,
      getOptionValue: getOptionValue
    })]
  });
});
var MemoSelect = exports.MemoSelect = /*#__PURE__*/React.forwardRef(function (_ref7, ref) {
  var children = _ref7.children,
    _ = _ref7.onAnimationStart,
    onChange = _ref7.onChange,
    onFocus = _ref7.onFocus,
    onBlur = _ref7.onBlur,
    props = _objectWithoutProperties(_ref7, _excluded);
  var onChangeMemoryRef = React.useRef(onChange);
  onChangeMemoryRef.current = onChange;
  var onChangeMemory = React.useCallback(function () {
    var _onChangeMemoryRef$cu;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    (_onChangeMemoryRef$cu = onChangeMemoryRef.current) === null || _onChangeMemoryRef$cu === void 0 || _onChangeMemoryRef$cu.call.apply(_onChangeMemoryRef$cu, [onChangeMemoryRef].concat(args));
  }, []);
  var onFocusMemoryRef = React.useRef(onFocus);
  onFocusMemoryRef.current = onFocus;
  var onFocusMemory = React.useCallback(function () {
    var _onFocusMemoryRef$cur;
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    (_onFocusMemoryRef$cur = onFocusMemoryRef.current) === null || _onFocusMemoryRef$cur === void 0 || _onFocusMemoryRef$cur.call.apply(_onFocusMemoryRef$cur, [onFocusMemoryRef].concat(args));
  }, []);
  var onBlurMemoryRef = React.useRef(onBlur);
  onBlurMemoryRef.current = onBlur;
  var onBlurMemory = React.useCallback(function () {
    var _onBlurMemoryRef$curr;
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }
    (_onBlurMemoryRef$curr = onBlurMemoryRef.current) === null || _onBlurMemoryRef$curr === void 0 || _onBlurMemoryRef$curr.call.apply(_onBlurMemoryRef$curr, [onBlurMemoryRef].concat(args));
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(SelectInput, _objectSpread(_objectSpread({
    onChange: onChangeMemory,
    onBlur: onBlurMemory,
    onFocus: onFocusMemory
  }, props), {}, {
    ref: ref,
    children: children
  }));
});
MemoSelect.propTypes = _objectSpread(_objectSpread({}, _SelectDropdown["default"].propTypes), {}, {
  hiddenInputValue: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number, _propTypes["default"].array]),
  id: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  SelectDisplayProps: _propTypes["default"].object,
  classes: _propTypes["default"].object,
  'data-cy-describedby': _propTypes["default"].string,
  className: _propTypes["default"].string,
  dataCy: _propTypes["default"].string,
  name: _propTypes["default"].string,
  placeholder: _propTypes["default"].string,
  progressColor: _propTypes["default"].string,
  type: _propTypes["default"].string,
  variant: _propTypes["default"].string,
  'data-cy-invalid': _propTypes["default"].bool,
  autoComplete: _propTypes["default"].bool,
  autoFocus: _propTypes["default"].bool,
  autoWidth: _propTypes["default"].bool,
  readOnly: _propTypes["default"].bool,
  displayEmpty: _propTypes["default"].bool,
  displayTooltip: _propTypes["default"].bool,
  dropdownWidth: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].number, _propTypes["default"].string]),
  loading: _propTypes["default"].bool,
  fetching: _propTypes["default"].bool,
  multiple: _propTypes["default"].bool,
  withLabel: _propTypes["default"].bool,
  required: _propTypes["default"].bool,
  labelId: _propTypes["default"].number,
  tabIndex: _propTypes["default"].number,
  defaultValue: _propTypes["default"].any,
  rows: _propTypes["default"].any,
  value: _propTypes["default"].array,
  filter: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  onKeyDown: _propTypes["default"].func,
  onKeyUp: _propTypes["default"].func,
  onOpen: _propTypes["default"].func,
  renderValue: _propTypes["default"].func
});
var _default = exports["default"] = MemoSelect;